export default __webpack_public_path__ + "static/media/element_spec_76.21c5b66e.jpg";